
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.6 1.6a8 8 0 100 16 8 8 0 000-16zm0 12a.8.8 0 01-.8-.8V9.6a.8.8 0 011.6 0v3.2a.8.8 0 01-.8.8zm.4-6.4h-.8a.4.4 0 01-.4-.4V6c0-.22.179-.4.4-.4h.8c.22 0 .4.18.4.4v.8a.4.4 0 01-.4.4z","fill":"#07193D"}})])
          )
        }
      }
    